import type { Ctx, HeaderRow, SettingRow, T } from "./connectorValues";

const SETTING_NAME = /^[a-z][a-z0-9_]{0,40}$/;
const HEADER_NAME = /^[A-Za-z0-9!#$%&'*+.^_`|~-]{1,100}$/;
// Credentials go in the connector's key or token, never in its plain headers (MHS-871).
const CREDENTIAL_HEADERS = new Set(["authorization", "proxy-authorization", "cookie", "x-api-key", "api-key"]);

function headerNameProblem(name: string, seen: Set<string>, t: T): string | null {
  if (!HEADER_NAME.test(name)) return t("form.errors.header");
  // Header names aren't case-sensitive: a second one would silently replace the first.
  if (seen.has(name.toLowerCase())) return t("form.headers.errors.duplicate");
  if (CREDENTIAL_HEADERS.has(name.toLowerCase())) return t("form.headers.errors.credential");
  return null;
}

export function checkHeaders(headers: HeaderRow[], ctx: Ctx, t: T) {
  const seen = new Set<string>();
  headers.forEach((row, i) => {
    const name = row.name.trim();
    const problem = headerNameProblem(name, seen, t);
    if (problem) ctx.addIssue({ code: "custom", path: ["headers", i, "name"], message: problem });
    seen.add(name.toLowerCase());
    if (/[\r\n]/.test(row.value) || row.value.length > 1000) {
      ctx.addIssue({ code: "custom", path: ["headers", i, "value"], message: t("form.headers.errors.value") });
    }
  });
}

export function checkSettings(settings: SettingRow[], ctx: Ctx, t: T) {
  const seen = new Set<string>();
  settings.forEach((row, i) => {
    if (!SETTING_NAME.test(row.name)) {
      ctx.addIssue({ code: "custom", path: ["settings", i, "name"], message: t("form.settings.errors.name") });
    } else if (seen.has(row.name)) {
      ctx.addIssue({ code: "custom", path: ["settings", i, "name"], message: t("form.settings.errors.duplicate") });
    }
    seen.add(row.name);
    if (!row.label.trim()) {
      ctx.addIssue({ code: "custom", path: ["settings", i, "label"], message: t("form.settings.errors.label") });
    }
    if (row.header.trim() && !HEADER_NAME.test(row.header.trim())) {
      ctx.addIssue({ code: "custom", path: ["settings", i, "header"], message: t("form.errors.header") });
    }
  });
}
